import { useEffect } from "react";
import { useLazyGetUserDetailsQuery } from "../../../store/slice/tradeApi";
import styles from "../admin.module.css";

function UserDetails({ userId }) {
  const [trigger, { data, isLoading, isError }] = useLazyGetUserDetailsQuery();

  useEffect(() => {
    trigger(userId);
  }, [userId, trigger]);

  if (isLoading) return <p>Chargement...</p>;
  if (isError) return <p>Erreur lors du chargement des détails</p>;
  if (!data) return null;

  const { portfolios, activeTrades } = data;

  return (
    <div className={styles.detailsContent}>
      <h4>Portfolios ({portfolios.length})</h4>
      {portfolios.length === 0 ? (
        <p className={styles.noData}>Aucun portfolio</p>
      ) : (
        <table className={styles.miniTable}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nom</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {portfolios.map((p) => (
              <tr key={p.id}>
                <td>{p.id}</td>
                <td>{p.title}</td>
                <td>{p.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <h4>Trades ({activeTrades.length})</h4>
      {activeTrades.length === 0 ? (
        <p className={styles.noData}>Aucun trade</p>
      ) : (
        <table className={styles.miniTable}>
          <thead>
            <tr>
              <th>UID</th>
              <th>Stock</th>
              <th>Portfolio</th>
              <th>Position</th>
              <th>Qté</th>
              <th>Prix entrée</th>
            </tr>
          </thead>
          <tbody>
            {activeTrades.map((t) => (
              <tr key={t.id}>
                <td>{t.uid}</td>
                <td>{t.stock}</td>
                <td>{t.portfolio}</td>
                <td>{t.position}</td>
                <td>{t.quantity}</td>
                <td>{t.enterPrice}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default UserDetails;
